/**
 * Códigos de tax system (`tax_system_config.code`) que el front usa por nombre: elegir la pantalla de una empresa en
 * los selectores por tax system (oferta, revisión del expediente, firma) o pedir su configuración en un cotizador.
 */
export const TAX_SYSTEMS_CODES = {
  // CREDIMOTO TAX SYSTEMS CODES
  CREDIMOTO_PF: "CSCM2",

  // MERCADER TAX SYSTEMS CODES
  // Mercader: cada vía de la decisión de ingresos tiene su tax system (con CIEC / sin CIEC).
  MERCADER_PFAE: "MER01",
  MERCADER_PM: "MER02",
  MERCADER_PFAE_SIN_CIEC: "MER03",
  MERCADER_PM_SIN_CIEC: "MER04",

  // FLUX TAX SYSTEMS CODES
  FLUX_PM: "FLXPM",
  FLUX_PFAE: "FLXPF",
  WUWEI_PF: "CAWWE",

  // PROVIDENCIA TAX SYSTEMS CODES
  PROVIDENCIA_CREDITO_SIMPLE_PM: "CFP01",
  PROVIDENCIA_CREDITO_SIMPLE_PFAE: "CFP02",
  PROVIDENCIA_CUENTA_CORRIENTE_PM: "CFP03",
  PROVIDENCIA_CUENTA_CORRIENTE_PFAE: "CFP04",
  PROVIDENCIA_AVIO_PM: "CFP01",
  PROVIDENCIA_AVIO_PFAE: "CFP02",
  PROVIDENCIA_REFACCIONARIO_PM: "CFP03",
  PROVIDENCIA_REFACCIONARIO_PFAE: "CFP04",
};
